import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
// import actions from "../../../../redux/VendorOrderList/actions";
import OrderActions from '../../../../redux/Order/actions';
import commonActions from '../../../../redux/Common/actions';
import Breadcrumb from "./Breadcrumb";
import { useHistory } from "react-router-dom";
import Preloader from '../../../layouts/Preloader';
import OtherActions from '../../../../redux/OtherProducts/actions';
import ReactPagination from '../../../common/React-Pagination';
import { float2D } from '../../../../utils/Validation';
import { BsArrowUp, BsArrowDown } from 'react-icons/bs';
import SortingOrders from '../../../common/SortingOrders';
import moment from 'moment';

export default function VendorOrdertable() {

    const dispatch = useDispatch();
    const history = useHistory();

    //get logged in users details
    const { token } = useSelector(state => state.authReducer);

    const { VendorOtherOrders } = useSelector(state => state.OtherProductReducer);

    //get orders list
    const { VendorsOrdersList } = useSelector(state => state.OrderReducer);

    const { Filtered_Dates } = useSelector(state => state.commonReducer);

    const [search, setsearch] = useState('');
    const [filteredData, setFilteredData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [postsPerPage, setPostPerPage] = useState(10);
    const [search2, setsearch2] = useState('');
    const [filteredData2, setFilteredData2] = useState([]);
    const [currentPage2, setCurrentPage2] = useState(0);
    const [postsPerPage2, setPostPerPage2] = useState(10);
    const [fetchSuccess, setFetchSuccess] = useState(false);
    const [startDate, setStartDate] = useState((Filtered_Dates?.Page === 'NCO' && moment(Filtered_Dates?.StartDate, 'DD-MM-YYYY').format('YYYY-MM-DD')) ? moment(Filtered_Dates?.StartDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '');
    const [startDate2, setStartDate2] = useState((Filtered_Dates?.Page === 'OPO' && moment(Filtered_Dates?.StartDate, 'DD-MM-YYYY').format('YYYY-MM-DD')) ? moment(Filtered_Dates?.StartDate, 'DD-MM-YYYY').format('YYYY-MM-DD') : '');

    //field: OD or DD / type: A or D
    let [sorting, setSorting] = useState([
        { table: 0, field: "OD", type: "D" },
        { table: 1, field: "OD", type: "D" },
    ]);

    //dispatch get orders list api
    useEffect(() => {
        if (token !== undefined) {
            dispatch({
                type: OrderActions.GET_VENDORS_NORMAL_CAKE_ORDERS_LIST_BY_SHOWTOVENDOR,
                payload: token?.result?._id
            })
            dispatch({
                type: OtherActions.GET_VENDOR_OTHER_PRODUCT_ORDERS_LIST,
                payload: token?.result?._id
            });
        };
        // eslint-disable-next-line
    }, [token]);

    //view details page
    const ViewOrderDetails = (orders) => {
        if (orders.Vendor_Response_Status === 'unseen') {
            dispatch({
                type: OrderActions.CHANGE_ORDER_VIEW_RESPONSE_BY_VENDOR,
                payload: { id: orders._id, response: 'seen' }
            })
        }
        history.push('/Vendor-OrderDetails', { page: 'orderlist', OrderId: orders._id });
    };

    const ViewProductOrderDetails = (orders) => {
        history.push('/vendor-product-order-details', { Id: orders._id, page: 'orderlist' });
    };

    //get search input value
    const handleSearchbar = (e) => {
        setsearch(e.target.value.toLowerCase());
        setCurrentPage(0);
    };

    //validate orders list is empty or not
    useEffect(() => {
        if (VendorsOrdersList?.message === 'No Records Found') {
            setFilteredData([]);
        } else {
            let FilteredDataWithDate = [];
            if (Filtered_Dates?.Page === 'NCO' && Filtered_Dates?.StartDate) {
                VendorsOrdersList.filter(val => {
                    if (moment(val.Created_On, 'DD-MM-YYYY hh:mm A').format('DD-MM-YYYY') === Filtered_Dates?.StartDate) {
                        return FilteredDataWithDate.push(val);
                    } else {
                        return null;
                    }
                });
            } else {
                FilteredDataWithDate = VendorsOrdersList;
            };
            setFilteredData(FilteredDataWithDate?.filter(val => {
                if (search === '') {
                    return val;
                } else if ((val.Id && val.Id.toLowerCase().includes(search)) ||
                    (val.CakeName && val.CakeName.toLowerCase().includes(search)) ||
                    (val.UserName && val.UserName.toLowerCase().includes(search)) ||
                    (val.Price && val.Price.toLowerCase().includes(search)) ||
                    (val.Status && val.Status.toLowerCase().includes(search)) ||
                    (val.DeliveryDate && val.DeliveryDate.toLowerCase().includes(search))
                ) {
                    return val;
                } else if (search.toLowerCase() === 'pending') {
                    if (val.Status !== 'Delivered' || val.Status !== 'Cancelled') {
                        return val;
                    } else {
                        return null;
                    }
                } else {
                    return null;
                }
            }))
        };
    }, [VendorsOrdersList, search, Filtered_Dates]);

    const indexOfFirstPost = (currentPage * postsPerPage) % filteredData?.length;
    const indexOfLastPost = indexOfFirstPost + postsPerPage;
    const currentdata = filteredData.slice(indexOfFirstPost, indexOfLastPost);

    // Change page
    const paginate = (event) => {
        setCurrentPage(event.selected);
    };

    const handleShowPerPage = (e) => {
        setPostPerPage(parseInt(e.target.value));
        setCurrentPage(0);
    };

    //get search input value
    const handleSearchbar2 = (e) => {
        setsearch2(e.target.value.toLowerCase());
        setCurrentPage2(0);
    };

    //validate orders list is empty or not
    useEffect(() => {
        if (VendorOtherOrders?.message === 'No Records Found') {
            setFilteredData2([]);
        } else {
            let FilteredDataWithDate = [];
            if (Filtered_Dates?.Page === 'OPO' && Filtered_Dates?.StartDate) {
                VendorOtherOrders.filter(val => {
                    if (moment(val.Created_On, 'DD-MM-YYYY hh:mm A').format('DD-MM-YYYY') === Filtered_Dates?.StartDate) {
                        return FilteredDataWithDate.push(val);
                    } else {
                        return null;
                    }
                });
            } else {
                FilteredDataWithDate = VendorOtherOrders;
            };
            setFilteredData2(FilteredDataWithDate.filter(val => {
                if (search2 === '') {
                    return val;
                } else if ((val.Id && val.Id.toLowerCase().includes(search2)) ||
                    (val.ProductName && val.ProductName.toLowerCase().includes(search2)) ||
                    (val.UserName && val.UserName.toLowerCase().includes(search2)) ||
                    (val.Total && val.Total.toLowerCase().includes(search2)) ||
                    (val.Status && val.Status.toLowerCase().includes(search2)) ||
                    (val.DeliveryDate && val.DeliveryDate.toLowerCase().includes(search2))
                ) {
                    return val;
                } else {
                    return null;
                }
            }))
        };
    }, [VendorOtherOrders, search2, Filtered_Dates]);

    const indexOfFirstPost2 = (currentPage2 * postsPerPage2) % filteredData2?.length;
    const indexOfLastPost2 = indexOfFirstPost2 + postsPerPage2;
    const currentdata2 = filteredData2.slice(indexOfFirstPost2, indexOfLastPost2);

    // Change page
    const paginate2 = (event) => {
        setCurrentPage2(event.selected);
    };

    const handleShowPerPage2 = (e) => {
        setPostPerPage2(parseInt(e.target.value));
        setCurrentPage2(0);
    };

    const handleSelectedDate = (e) => {
        setStartDate(e.target.value);
        setStartDate2('');
        if (e.target.value) {
            dispatch({ type: commonActions.SET_START_AND_END_DATE, payload: { StartDate: moment(e.target.value, 'YYYY-MM-DD').format('DD-MM-YYYY'), Page: 'NCO' } });
        } else {
            dispatch({ type: commonActions.SET_START_AND_END_DATE, payload: { StartDate: null, Page: null } });
        };
        setCurrentPage(0);
        let newArray = sorting;
        newArray[0].field = 'OD';
        newArray[0].type = 'D';
        setSorting(newArray);
        // if (e.target.value) {
        // setFilteredData(VendorsOrdersList.filter(val => {
        //     if ((val.Created_On.slice(0, 10).split("-").reverse().join("-")) === e.target.value) {
        //         return val;
        //     } else {
        //         return null;
        //     }
        // }));
        // } else {
        //     setFilteredData(VendorsOrdersList)
        // }
    };

    const handleSelectedDate2 = (e) => {
        setStartDate2(e.target.value);
        setStartDate('');
        if (e.target.value) {
            dispatch({ type: commonActions.SET_START_AND_END_DATE, payload: { StartDate: moment(e.target.value, 'YYYY-MM-DD').format('DD-MM-YYYY'), Page: 'OPO' } });
        } else {
            dispatch({ type: commonActions.SET_START_AND_END_DATE, payload: { StartDate: null, Page: null } });
        };
        setCurrentPage2(0);
        let newArray = sorting;
        newArray[1].field = 'OD';
        newArray[1].type = 'D';
        setSorting(newArray);
        // if (e.target.value) {
        //     setFilteredData2(VendorOtherOrders.filter(val => {
        //         if ((val.Created_On.slice(0, 10).split("-").reverse().join("-")) === e.target.value) {
        //             return val;
        //         } else {
        //             return null;
        //         }
        //     }));
        // } else {
        //     setFilteredData2(VendorOtherOrders)
        // }
    };

    const handlePageRefresh = (e) => {
        e.preventDefault();
        dispatch({
            type: OrderActions.GET_VENDORS_NORMAL_CAKE_ORDERS_LIST_BY_SHOWTOVENDOR,
            payload: token?.result?._id
        })
        dispatch({
            type: OtherActions.GET_VENDOR_OTHER_PRODUCT_ORDERS_LIST,
            payload: token?.result?._id
        });
        setSorting([
            { table: 0, field: "OD", type: "D" },
            { table: 1, field: "OD", type: "D" }
        ]);
        setStartDate();
        setStartDate2();
        setsearch('');
        setsearch2('');
    };

    const handleSorting = (e, field, table) => {
        e.preventDefault();
        let type, filterData;
        (sorting[table]?.type === 'A') ? type = 'D' : type = 'A';
        let newArray = [...sorting];
        newArray[table].type = type;
        newArray[table].field = field;
        setSorting(newArray);
        (table === 0) ? filterData = filteredData : filterData = filteredData2;
        let result = SortingOrders({ type, field, filterData });
        (table === 0) ? setFilteredData(result) : setFilteredData2(result);
    };

    //loading
    useEffect(() => {
        (VendorsOrdersList.length === 0 || VendorOtherOrders.length === 0) ?
            setFetchSuccess(false) : setFetchSuccess(true);
        // eslint-disable-next-line
    }, [VendorsOrdersList, VendorOtherOrders]);

    return (
        <>
            {!fetchSuccess ?
                <Preloader fetchSuccess={fetchSuccess} /> :
                <div className="ms-content-wrapper">
                    <div className="row">
                        <div className="col-md-12">
                            <Breadcrumb handlePageRefresh={handlePageRefresh} />
                            <div className="ms-panel">
                                <div className="ms-panel-body tabledata-background">
                                    <h6 className='text-uppercase font-weight-bold'>Vendor Orders List</h6>
                                    <span className="float-right add-banner-button col-sm-3 col-md-3 mb-2">
                                        <div id="data-table-4_filter" className="dataTables_filter">
                                            <input
                                                type='date'
                                                maxLength={4}
                                                max={"9999-12-31"}
                                                disabled={VendorsOrdersList?.message === 'No Records Found' ? true : false}
                                                className="form-control mt-4"
                                                aria-controls="data-table-4"
                                                onChange={handleSelectedDate}
                                                value={startDate || ''}
                                            />
                                        </div>
                                    </span>
                                </div>
                                <div className='header-break-line'> <hr /> </div>
                                <div className="ms-panel-body tabledata-background">
                                    <div className="table-responsive Scrollbar-Style">
                                        <div id="data-table-5_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <div className="dataTables_length" id="data-table-5_length">
                                                        <label>
                                                            Show
                                                            <select name="data-table-5_length" aria-controls="data-table-5" className="custom-select custom-select-sm form-control form-control-sm" onChange={handleShowPerPage}>
                                                                <option value="10">10</option>
                                                                <option value="25">25</option>
                                                                <option value="50">50</option>
                                                            </select> entries
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-6 mb-2">
                                                    <div id="data-table-4_filter" className="dataTables_filter">
                                                        <label className="font-weight-bold">Search :
                                                            <input
                                                                type='Search'
                                                                className="form-control form-control-sm"
                                                                placeholder="type here to search..."
                                                                onChange={handleSearchbar}
                                                                value={search || ''}
                                                                aria-controls="data-table-4"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <table id="data-table-5" className="table w-100 thead-primary dataTable no-footer table-hover" role="grid" aria-describedby="data-table-5_info">
                                                        <thead>
                                                            <tr role="row">
                                                                <th scope="col">Order ID</th>
                                                                <th scope="col">Cake Name</th>
                                                                <th scope="col">Customer Name</th>
                                                                <th scope="col">Ordered Date <span className='cursor' onClick={(e) => handleSorting(e, 'OD', 0)}><BsArrowUp className={`sort-up-arrow ${sorting[0]?.table === 0 && sorting[0]?.field === 'OD' && sorting[0]?.type === 'A' ? 'sort-ascending' : 'sort-false'}`} /><BsArrowDown className={`sort-down-arrow ${sorting[0]?.table === 0 && sorting[0]?.field === 'OD' && sorting[0]?.type === 'D' ? 'sort-descending' : 'sort-false'}`} /></span></th>
                                                                <th scope="col">Delivery Date <span className='cursor' onClick={(e) => handleSorting(e, 'DD', 0)}><BsArrowUp className={`sort-up-arrow ${sorting[0]?.table === 0 && sorting[0]?.field === 'DD' && sorting[0]?.type === 'A' ? 'sort-ascending' : 'sort-false'}`} /><BsArrowDown className={`sort-down-arrow ${sorting[0]?.table === 0 && sorting[0]?.field === 'DD' && sorting[0]?.type === 'D' ? 'sort-ascending' : 'sort-false'}`} /></span></th>
                                                                <th scope="col">Order Status</th>
                                                                <th scope="col">Price</th>
                                                            </tr>
                                                        </thead>
                                                        {filteredData.length > 0 ?
                                                            <tbody>
                                                                {currentdata.map((order) =>
                                                                    <tr className={(order.Vendor_Response_Status === 'unseen' || order.Vendor_Response_Status === 'no response') ? 'odd cursor font-weight-bold' : 'odd cursor'} key={order._id} onClick={() => ViewOrderDetails(order)}>
                                                                        <th className='id-column' scope="row">{order.Id}</th>
                                                                        <td><span className={order.CakeName ? '' : 'font-weight-bold text-success'}>{order.CakeName ? order.CakeName : 'Customised Cake'}</span></td>
                                                                        <td> {order.UserName}</td>
                                                                        <td> {order.Created_On}</td>
                                                                        <td>{order.DeliveryDate}</td>
                                                                        <td><span className={(order.Status?.toUpperCase())?.replace(/ /g, '')}>{order.Status}</span></td>
                                                                        {(order.CakeID && order?.Vendor_Price && order?.TypeOfCustomizedCake === 'Cakey') ?
                                                                            <td className='sales-alignment price-align3-row'>{float2D(order?.Vendor_Price)}</td> :
                                                                            (order.CakeID && order?.Vendor_Price && order?.TypeOfCustomizedCake === 'Vendor') ?
                                                                                <td className='sales-alignment price-align3-row'>{order?.NewPrice ? float2D(parseFloat(order?.NewPrice)) : float2D(order?.Vendor_Price)}</td> :
                                                                                <td className='sales-alignment price-align3-row'>{float2D(order?.Price)}</td>
                                                                        }
                                                                        {/* <td className='sales-alignment price-align3-row'>{float2D(order.Price)}</td> */}
                                                                    </tr>
                                                                )}
                                                            </tbody> :
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={7} className='font-weight-bold no-records-found'>No Records Found</td>
                                                                </tr>
                                                            </tbody>
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {filteredData.length > postsPerPage &&
                                        <ReactPagination
                                            paginate={paginate}
                                            pageCount={Math.ceil(filteredData?.length / postsPerPage)}
                                            currentPage={currentPage}
                                            currentdata={currentdata}
                                            totalPosts={filteredData.length}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-12">
                            <div className="ms-panel">
                                <div className="ms-panel-body tabledata-background">
                                    <h6 className='text-uppercase font-weight-bold'>Vendor Other Product Orders List</h6>
                                    <span className="float-right add-banner-button col-sm-3 col-md-3 mb-2">
                                        <div id="data-table-4_filter" className="dataTables_filter">
                                            <input
                                                type='date'
                                                className="form-control mt-4"
                                                maxLength={4}
                                                max={"9999-12-31"}
                                                disabled={VendorOtherOrders?.message === 'No Records Found' ? true : false}
                                                aria-controls="data-table-4"
                                                onChange={handleSelectedDate2}
                                                value={startDate2 || ''}
                                            />
                                        </div>
                                    </span>
                                </div>
                                <div className='header-break-line'> <hr /> </div>
                                <div className="ms-panel-body tabledata-background">
                                    <div className="table-responsive Scrollbar-Style">
                                        <div id="data-table-5_wrapper" className="dataTables_wrapper dt-bootstrap4 no-footer">
                                            <div className="row">
                                                <div className="col-sm-12 col-md-6">
                                                    <div className="dataTables_length" id="data-table-5_length">
                                                        <label>
                                                            Show
                                                            <select name="data-table-5_length" aria-controls="data-table-5" className="custom-select custom-select-sm form-control form-control-sm" onChange={handleShowPerPage2}>
                                                                <option value="10">10</option>
                                                                <option value="25">25</option>
                                                                <option value="50">50</option>
                                                            </select> entries
                                                        </label>
                                                    </div>
                                                </div>
                                                <div className="col-sm-12 col-md-6 mb-2">
                                                    <div id="data-table-4_filter" className="dataTables_filter">
                                                        <label className="font-weight-bold">Search :
                                                            <input
                                                                type='Search'
                                                                className="form-control form-control-sm"
                                                                placeholder="type here to search..."
                                                                onChange={handleSearchbar2}
                                                                value={search2 || ''}
                                                                aria-controls="data-table-4"
                                                            />
                                                        </label>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-sm-12">
                                                    <table id="data-table-5" className="table w-100 thead-primary dataTable no-footer table-hover" role="grid" aria-describedby="data-table-5_info">
                                                        <thead>
                                                            <tr role="row">
                                                                <th scope="col">Order ID</th>
                                                                <th scope="col">Product Name</th>
                                                                <th scope="col">Customer Name</th>
                                                                <th scope="col">Ordered Date <span className='cursor' onClick={(e) => handleSorting(e, 'OD', 1)}><BsArrowUp className={`sort-up-arrow ${sorting[1]?.table === 1 && sorting[1]?.field === 'OD' && sorting[1]?.type === 'A' ? 'sort-ascending' : 'sort-false'}`} /><BsArrowDown className={`sort-down-arrow ${sorting[1]?.table === 1 && sorting[1]?.field === 'OD' && sorting[1]?.type === 'D' ? 'sort-descending' : 'sort-false'}`} /></span></th>
                                                                <th scope="col">Delivery Date <span className='cursor' onClick={(e) => handleSorting(e, 'DD', 1)}><BsArrowUp className={`sort-up-arrow ${sorting[1]?.table === 1 && sorting[1]?.field === 'DD' && sorting[1]?.type === 'A' ? 'sort-ascending' : 'sort-false'}`} /><BsArrowDown className={`sort-down-arrow ${sorting[1]?.table === 1 && sorting[1]?.field === 'DD' && sorting[1]?.type === 'D' ? 'sort-ascending' : 'sort-false'}`} /></span></th>
                                                                <th scope="col">Order Status</th>
                                                                <th scope="col">Price</th>
                                                            </tr>
                                                        </thead>
                                                        {filteredData2.length > 0 ?
                                                            <tbody>
                                                                {currentdata2.map((order) =>
                                                                    <tr className={(order.Vendor_Response_Status === 'unseen' || order.Vendor_Response_Status === 'no response') ? 'odd cursor font-weight-bold' : 'odd cursor'} key={order._id} onClick={() => ViewProductOrderDetails(order)}>
                                                                        <th className='id-column' scope="row">{order.Id}</th>
                                                                        <td><span>{order.ProductName}</span></td>
                                                                        <td> {order.UserName}</td>
                                                                        <td> {order.Created_On}</td>
                                                                        <td>{order.DeliveryDate}</td>
                                                                        <td><span className={(order.Status?.toUpperCase())?.replace(/ /g, '')}>{order.Status}</span></td>
                                                                        <td className='sales-alignment price-align3-row'>{float2D(order.Total)}</td>
                                                                    </tr>
                                                                )}
                                                            </tbody> :
                                                            <tbody>
                                                                <tr>
                                                                    <td colSpan={7} className='font-weight-bold no-records-found'>No Records Found</td>
                                                                </tr>
                                                            </tbody>
                                                        }
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {filteredData2.length > postsPerPage2 &&
                                        <ReactPagination
                                            paginate={paginate2}
                                            pageCount={Math.ceil(filteredData2?.length / postsPerPage2)}
                                            currentPage={currentPage2}
                                            currentdata={currentdata2}
                                            totalPosts={filteredData2.length}
                                        />
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            }
        </>
    );
}